import SEO from '../components/SEO';

export default function EdutainmentPage() {
  return (
    <>
      <SEO
        title="Edutainment"
        description="Edutainment from Galaxy Brain Entertainment — Synapse, Eureka, and AHAB. Games and benchmarks for the linguistically curious."
        canonical="/edutainment"
        keywords="semantic games, word games, Synapse, Eureka, AHAB, alignment benchmarks, educational games, NLP games"
        structuredData={[
          {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: 'Synapse',
            description: 'Semantic word navigation game — find paths through meaning space by chaining related concepts.',
            url: 'https://synapse.gbe.games',
            applicationCategory: 'GameApplication',
            author: {
              '@type': 'Organization',
              name: 'Galaxy Brain Entertainment',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: 'Eureka',
            description: 'A game of reasoning and discovery — multiplayer card game with Bayesian AI bots.',
            url: 'https://eureka.gbe.games',
            applicationCategory: 'GameApplication',
            author: {
              '@type': 'Organization',
              name: 'Galaxy Brain Entertainment',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: 'AHAB',
            description: 'AI Human Alignment Benchmarks. Four interactive tasks measuring how human linguistic intuitions align with language model representations.',
            url: 'https://aihumanalignment.com',
            applicationCategory: 'GameApplication',
            author: {
              '@type': 'Organization',
              name: 'Galaxy Brain Entertainment',
            },
          },
        ]}
      />

      <div className="px-6 md:px-12 lg:px-16 pt-24 max-w-3xl">
        <section className="pt-16 md:pt-24 pb-16 md:pb-20 animate-fade-in">
          <h1 className="font-serif text-3xl md:text-4xl mb-2">
            Galaxy Brain Entertainment
          </h1>
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-vellum-muted mb-8">
            Entertaining exercises in meaning and discovery
          </p>
          <div className="w-10 h-px bg-rule mb-12" />

          {/* Synapse */}
          <div className="mb-16">
            <h2 className="font-serif text-2xl mb-4">
              Synapse
            </h2>
            <p className="font-serif text-base text-vellum leading-relaxed mb-4">
              A daily word game. Navigate an AI model's semantic space — chain related concepts from start to finish, and discover how machines organize meaning.
            </p>
            <a
              href="https://synapse.gbe.games"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-accent hover:underline"
            >
              synapse.gbe.games &rarr;
            </a>
          </div>

          {/* Eureka */}
          <div className="mb-16">
            <h2 className="font-serif text-2xl mb-4">
              Eureka
            </h2>
            <p className="font-serif text-base text-vellum leading-relaxed mb-4">
              A card game of pattern recognition and discovery. Identify hidden rules governing how cards relate — play solo or against AI opponents as the patterns grow more complex. Based on Eleusis.
            </p>
            <a
              href="https://eureka.gbe.games"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-accent hover:underline"
            >
              eureka.gbe.games &rarr;
            </a>
          </div>

          {/* AHAB */}
          <div className="mb-16">
            <h2 className="font-serif text-2xl mb-4">
              AHAB
            </h2>
            <p className="font-serif text-base text-vellum leading-relaxed mb-4">
              AI Human Alignment Benchmarks. Four interactive tasks &mdash; similarity, proximity, word sense, and prediction &mdash; that measure how your linguistic intuitions line up with language model representations.
            </p>
            <a
              href="https://aihumanalignment.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-accent hover:underline"
            >
              aihumanalignment.com &rarr;
            </a>
          </div>
        </section>
      </div>
    </>
  );
}
